const DEFAULT_PRIORITY = 5;

export function getModalByName(name: string): HTMLUxModalElement {
    const modal: HTMLUxModalElement = document.querySelector(`ux-modal[name="${name}"]`);
    return modal;
}

export function getPriority(name: string) {
    const modal = getModalByName(name);
    // eslint-disable-next-line @stencil-community/strict-boolean-conditions
    if (modal === null || !modal.priority || isNaN(modal.priority)) {
        return DEFAULT_PRIORITY;
    }
    return modal.priority;
}
